import axios, { AxiosError } from 'axios';
// import useUserStore from '../store/userStore';

export const baseURL = process.env.NODE_ENV === 'production'
    ? 'https://wm.pastelcloud.net'
    : 'http://localhost:8080';

export const authURL = process.env.NODE_ENV === 'production'
    ? 'https://auther.pastelcloud.net'
    // : 'http://localhost:9000';
    : 'https://auther.pastelcloud.net';

export const clientURL = process.env.NODE_ENV === 'production'
    ? 'https://wmd.pastelcloud.net'
    : 'http://localhost:3000';

const apiClient = axios.create({
    baseURL: baseURL,
    withCredentials: true,
});

// --- 응답 인터셉터 ---
// 401(Unauthorized) 또는 403(Forbidden) 에러 발생 시 자동 로그아웃 처리합니다.
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error: AxiosError) => {
        const responseData = error.response?.data as any;

        if (error.response && error.response.status === 401) {
            // Zustand 스토어의 clearUser 함수를 직접 호출하여 로그아웃 처리합니다.
            // clearUser는 이제 로그아웃 API를 호출합니다.
            // useUserStore.getState().clearUser();

            // 로그인 페이지로 리디렉션합니다.
            // window.location.href는 페이지를 새로고침하므로 상태가 초기화됩니다.
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        // 2. 403 Forbidden: 인증은 됐으나 클라이언트 DB에 없는 경우
        if (error.response?.status === 403 && responseData?.code === 'NOT_REGISTERED') {
            // 회원가입 페이지로 이동하되, 서버가 준 id를 쿼리 파라미터로 전달
            const userId = responseData?.userId || '';
            window.location.href = `/register?id=${userId}`;
            return new Promise(() => {});
        } else if (error.response?.status === 403 && !responseData?.code) {
            // 코드가 있는 403(예: 1014 프로젝트 멤버 아님, 1017 담당자는 진행만)은 '이 일을 할 권한 없음'이라
            // 로그아웃하지 않고 호출한 쪽이 처리한다. 코드 없는 403(보안 필터가 막음)만 로그인으로 보낸다.
            // Zustand 스토어의 clearUser 함수를 직접 호출하여 로그아웃 처리합니다.
            // clearUser는 이제 로그아웃 API를 호출합니다.
            // useUserStore.getState().clearUser();

            // 로그인 페이지로 리디렉션합니다.
            // window.location.href는 페이지를 새로고침하므로 상태가 초기화됩니다.
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;

